import {useState,useEffect} from 'react'
import logo from "../../assets/images/Inca-Logo-WHite 1.svg";
import sliderCloseImage from "../../assets/images/slider-close-icon.svg";
import usersIcon from "../../assets/images/users-icon.svg"
import $ from 'jquery'


import { Link,useLocation,useNavigate } from "react-router-dom";
import { useSelector ,dispatch, useDispatch} from 'react-redux';
import {fetchContacts, updateActiveAccount,signoutUser,fetchMessages,fetchUnReadCountData,fetchVoicemails,logoutAsync } from '../../redux/action';
import authReducer from '../../redux/reducers/authReducer';

function LeftNavigation() {

  const dispatch=useDispatch()
  const authUser=useSelector((state)=>state.authUser)
  const notifications=useSelector((state)=>state.notifications)

  const [active,setActive]=useState(authUser.activeAccount)

  useEffect(()=>{
     setActive(authUser.activeAccount)
  },[])

  const getMessages=()=>{
    dispatch(fetchUnReadCountData())
    dispatch(fetchMessages())
  }

  const getVoicemails=()=>{
    dispatch(fetchVoicemails())
  }

  const hideLeft=()=>{

    $(".left-navigation").animate({
      width: 0,
      padding: 0
  }, function () {
      $(".main-section").css("width", "100%");
      $("#leftMenuBtn").addClass("d-none");
      $("#headerMenuBtn").removeClass("d-none");
  });
    

  }

  
  const handleMobileLeftBtn=()=>{
    $(".left-navigation").css('display', 'none');
  }

  const fetchContactsData=()=>{
    dispatch(fetchContacts())  }

  useEffect(()=>{
    fetchContactsData()
  },[])
 
  
  
 
  return (
    <div className="col-md-3 col-lg-3 col-sm-12 col-xs-12 left-navigation">
      <div className="d-flex flex-column justify-content-between ">
        <div className=''>
          <div className="d-flex justify-content-between">
            <img alt=" " src={logo} className="img-fluid" />
            <button id="leftMenuBtn" onClick={hideLeft} className="menu-btn me-2 desktop-display">
              <i className="fa-solid fa-bars"></i>
            </button>
            <button
              onClick={handleMobileLeftBtn}
              id="mobileLeftMenuBtn"
              className="slider-close-btn me-2 mobile-display"
            >
              <img alt=" " src={sliderCloseImage} className="img-fluid" />
            </button>
          </div>


     <div className="mt-5">
      {notifications.data.map((item)=>(
        <div key={item.id} className='d-flex align-items-center justify-content-between'>
            <div className="mb-3 d-flex align-items-center justify-content-between w-100" onClick={()=>{dispatch(updateActiveAccount(item.account.id));setActive(item.account.id)}}>
                <a href='#' className='d-flex align-items-center'>
                <img alt=" " src={usersIcon} />
                <p className={`nav-text ms-3 mb-0 ${authUser.activeAccount==item.account.id && 'active'}`}>{item.account.name}</p>
                </a>
             <div>   
               {item.messages.length>0 && <span className='messages-count'>{item.messages.length}</span>}
              </div>
        </div>
            </div>
      ))}
       </div>

          
         
          
          
          

       


          
       



        </div>
         
    
      </div>
    </div>
  );
}

export default LeftNavigation;
